import React, { useCallback } from "react";
import Spec from "./Spec";
import PT from "prop-types";
import Context from "./context";
import SectHeader from "_c/modules/profile/common/SectHeader";
import Info from "_c/atoms/Info";
import isempty from "lodash/isEmpty";
import AddService from "./AddService";
import { analyticsAction } from "@/utils/analytics";
import { useMasterServiceEditor } from "@/hooks/useMasterServiceEditor";

const SaloonServices = (props) => {
  const openEditor_ = useMasterServiceEditor();
  const openEditor = useCallback(
    ({ master, service }) => {
      if (!service) {
        analyticsAction({
          category: "service",
          action: "salon_service_form_opened",
        });
      }
      openEditor_({
        masterId: master,
        service,
        onCreate() {
          analyticsAction({
            category: "salon_profile",
            action: "salon_new_service",
          });
        },
      });
    },
    [openEditor_],
  );
  return (
    <Context.Provider
      value={{
        t: props.t,
        addToBasket: props.addToBasket,
        authMasterId: props.authMasterId,
        authUserId: props.authUserId,
        openServiceEditor: openEditor,
        isOwner: props.isOwner,
        canEditServices: props.canEditServices,
        deleteService: props.deleteService,
      }}
    >
      <div
        id="master-services-container"
        css={`
          @media (max-width: 575px) {
            padding: 0 15px;
          }
        `}
      >
        <SectHeader>{props.t("common:service_many")}</SectHeader>
        {props.canEditServices && (
          <AddService t={props.t} onMasterSelect={openEditor} />
        )}
        {isempty(props.services) ? (
          <Info>
            {props.t(
              `saloon_profile:services.${
                props.canEditServices ? "empty_owner" : "empty_guest"
              }`,
            )}
          </Info>
        ) : (
          props.services.map(({ spec, titles }) => (
            <Spec
              basket={props.basket}
              key={spec._id}
              spec={spec}
              titles={titles}
            />
          ))
        )}
      </div>
    </Context.Provider>
  );
};
SaloonServices.propTypes = {
  services: PT.array,
  authUserId: PT.string,
  authUserId: PT.string,
  basket: PT.array,
  isOwner: PT.bool,
  canEditServices: PT.bool,

  t: PT.func.isRequired,
  addToBasket: PT.func.isRequired,
};

export default SaloonServices;
